import { createApiMutationHook, IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, RelationalValue } from "../../utils/filters";
import { ICategoryResource } from "../types";

export type ICategoryTranslationUpdateMutationParameters = {
    category: RelationalValue<ICategoryResource>;
    locale: string;
    title: string;
};

export type ICategoryTranslationUpdateMutationResult = ICategoryResource;

export const categoryTranslationUpdateMutation: IApiMutationFunction<ICategoryTranslationUpdateMutationParameters> = ({
    category,
    locale,
    title,
}) => ({
    method: "PUT",
    url: `/categories/${mapRelationalValue(category)}`,
    data: { title },
    headers: { "x-locale": locale },
});

export const useCategoryTranslationUpdateMutation = createApiMutationHook<
    ICategoryTranslationUpdateMutationParameters,
    ICategoryTranslationUpdateMutationResult
>(categoryTranslationUpdateMutation);
